import gql from 'graphql-tag';

export const HoverPageCardsOptStatusQuery = gql`
	query HoverPageCardsOptStatusQuery {
		userPreferences {
			shouldShowCardOnPageTreeHover
		}
	}
`;
